export default "__VITE_ASSET__DNzar9q7__"